// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3XRMU","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__35oMJ"};